import {useGraphql} from "@/core/graphql/service";
import {useBus} from "@/core/store/bus";
import {scrollTo} from "@/core/util/scrollTo";
import {useBasketStore} from "@/modules/shop/store/basket";
import {useDeliveryStore} from "@/modules/shop/store/delivery";
import {VorderTab} from "@/modules/shop/store/util/vorder";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import {useVorderValidate} from "@/modules/shop/store/vorder-validate";
import {storeToRefs} from "pinia";
import {QForm} from "quasar";
import {computed, nextTick, onBeforeUnmount, onMounted, Ref, ref} from "vue";
import {useVorderSubmit} from "@/modules/shop/store/vorder-submit";
import {useRouter} from "vue-router";
import {useDebugComponent} from "@/core/composable/useDebugComponent";
import {useYandexMetrikaStore} from "@/modules/yandex/store/metrika";
import {useStackRouter} from "@/packages/stack-router/hooks/useStackRouter";
import PaymentDialog from "@/components/Shop/VOrder/ui/Dialog/Payment.vue";

export type UseVorderComponentReturn = ReturnType<typeof useVorderComponent>

export function useVorderComponent(form: Ref<QForm | undefined>) {

    const {bus} = useBus()

    const stackRouter = useStackRouter()

    const paymentConfirmShown = ref(false)

    const vorderState = useVorderState()
    const validateStore = useVorderValidate()
    const basketStore = useBasketStore()
    const deliveryStore = useDeliveryStore()
    const vorderSubmit = useVorderSubmit()
    const yandexMetrika = useYandexMetrikaStore()

    const {submitToServer} = vorderSubmit

    const {validate: storeValidate} = validateStore

    const {
        validateResultCommon,
        validateResultBasketItems
    } = storeToRefs(validateStore)

    const {
        basketItemModelByProduct
    } = storeToRefs(basketStore)

    const {
        tab,
        attrs,
    } = storeToRefs(vorderState)

    const scrollToErrors = () => {
        const errorElm = form.value?.$el.querySelector('.q-field--error')
        scrollTo(errorElm, 0, {}, '.c-body')
    }

    const validate = async () => {

        if (basketStore.basketIsEmpty) {
            console.log('basket is empty');
            return false
        }

        if (!form.value)
            return false
        try {
            if (!storeValidate() || !(await form.value.validate(true))) {
                await nextTick()
                scrollToErrors()
                return false
            }
            return true
        } catch (e) {
            console.log(e)
            scrollToErrors()
            return false
        }
    }

    const router = useRouter()

    const submit = async () => {
        if (basketStore.basketIsEmpty) {
            console.log('basket is empty');
            return
        }
        if (await validate()) {
            if (!paymentConfirmShown.value) {
                stackRouter.getStack()?.push(PaymentDialog, {
                    fromSection: 'payment',
                    fromSubmit: true,
                })
                paymentConfirmShown.value = true
                return;
            }

            // Открываем диалог подтверждения заказа
            // bus.emit('router:push', '/shop/vorder-confirm')
            const res = await submitToServer()

            console.log('res', res)

            if (res.success) {
                yandexMetrika.triggerGoal('zakaz-on')
                tab.value = 'basket'
                if (res.payload) {
                    if (res.payload.orderUrl) {
                        router.push(res.payload.orderUrl)
                    }
                }
            }

        } else {
            console.log('VALID FAIL')
        }
    }

    onMounted(() => {
        bus.on('vorder:validate', validate)
    })

    onBeforeUnmount(() => {
        bus.off('vorder:validate', validate)
    })

    const {mutationWrapped} = useGraphql()

    const onMutate = async () => {

        /*
        const res = await mutationWrapped(
            userPubLoginRequestMutation({
                sid: true,
                state: {
                    __fragment: 'ResponseState'
                }
            }, {
                phone: '79500000000',
                confirmMode: 'call'
            })
        )

         */

        console.log('mutationWrapped')
    }

    const changeTab = (newTab: VorderTab) => {
        tab.value = newTab
    }

    const commonErrors = computed(() => {
        let errors = validateResultCommon.value
        if (!errors.length && tab.value === 'form') {
            if (validateResultBasketItems.value.length) {
                errors = validateResultBasketItems.value
            }
        }
        return errors
    })

    const commonAlertMessages = computed(() => {
        return commonErrors.value.map(error => error.message)
    })

    const showBasketAction = computed(() => {
        return commonErrors.value.some(error => error.section === 'basket_item')
    })

    const debug = useDebugComponent('Vorder', {
        actions: [
            {
                label: 'Проверить время',
                onClick: () => {
                    deliveryStore.deliveryCalculate()
                }
            }
        ],
        fields: [
            {
                label: 'discountDebug',
                json: true,
                value: computed(() => {
                    return {}
                })
            },
        ]
    })

    bus.on('vorder:submit', submit)

    return {
        tab,
        form,
        validate,
        submit,
        scrollToErrors,
        onMutate,
        attrs,
        changeTab,
        commonErrors,
        commonAlertMessages,
        showBasketAction,
        debug
    }
}
